import React from 'react'
import { withIcon } from '../../withIcon'

function CaretRightOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M16.553 11.5438C16.8049 11.7958 16.8049 12.2042 16.553 12.4562L10.3594 18.6497C10.1749 18.8343 9.89742 18.8895 9.65634 18.7896C9.41526 18.6897 9.25807 18.4545 9.25807 18.1935V5.80646C9.25807 5.54552 9.41526 5.31027 9.65634 5.21041C9.89742 5.11056 10.1749 5.16575 10.3594 5.35027L16.553 11.5438ZM10.5484 7.36402V16.636L15.1844 12L10.5484 7.36402Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretRightOutlineIcon)
